{
  "AllNotifications": "所有通知",
  "NoLinkNotification": "没有此通知的链接",
  "ViewAllAnnouncementTab": "公告",
  "ViewallNotificationTab": "通知",
  "preferences": "编辑首选项"
}
